import type { PropsWithChildren } from 'react'
import { AuthForm } from '../AuthForm'
import { Dialog } from '../DialogV2'
import { Portal } from '../portal'

export interface MoteAnonymousExpiredDialogProps {
  isOpen: boolean
  onSignIn: () => void
  onSignUp: () => void
}

export const MoteAnonymousExpiredDialog = (
  props: PropsWithChildren<MoteAnonymousExpiredDialogProps>
): JSX.Element => {
  return (
    <Dialog
      isOpen={props.isOpen}
      onClose={() => {}}
      maxWidth={440}
      showCloseButton={false}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      overlayProps={{
        bg: 'blackAlpha.400',
        style: { backdropFilter: 'blur(12px)' }
      }}
    >
      <Dialog.Content p='40px !important'>
        <AuthForm
          title={'Sign up for access'}
          subtitle={
            "It’s been longer than 24 hours since you created your mote, we’ve put it to bed for a snooze, wake it up by signing up below before it permanently expires in 3 days' time"
          }
          caption={'Already have an account?'}
          cta={{
            text: 'Sign up with Google',
            action: props.onSignUp
          }}
          redirect={{
            text: 'Sign in',
            action: props.onSignIn
          }}
        />
      </Dialog.Content>
      <Portal>{props.children}</Portal>
    </Dialog>
  )
}
